/**
 * The URL shapes the app builds, in one place: REST paths handed to `apiFetch`
 * and the router paths behind every agent link. Pages used to re-derive these
 * inline, which is how an un-encoded agent id eventually slips through.
 */
import type { RunSummary } from "@/models";

export function encoded(value: string): string {
  return encodeURIComponent(value);
}

export function agentPath(agentId: string, suffix: string): string {
  return `/agents/${encoded(agentId)}${suffix}`;
}

export function sessionPath(agentId: string, sessionId: string, suffix = ""): string {
  return `${agentPath(agentId, `/sessions/${encoded(sessionId)}`)}${suffix}`;
}

/** Router path for a run's detail page. */
export function runLink(run: RunSummary): string {
  return `/agents/${encoded(run.agentId)}/runs/${encoded(run.runUid)}`;
}
